import { forwardRef, CSSProperties } from 'react';

import logoSrc from '../../assets/images/logo-dnj.png';

// ----------------------------------------------------------------------

export interface NavLogoProps {
  disabledLink?: boolean;
  style?: CSSProperties;
}

const NavLogo = forwardRef<HTMLDivElement, NavLogoProps>(
  ({ disabledLink = false, style, ...other }, ref) => {
    const logo = (
      <div
        ref={ref}
        style={{
          width: 150,
          height: 40,
          display: 'inline-flex',
          ...style,
        }}
        {...other}
      >
        <img src={logoSrc} />
      </div>
    );

    if (disabledLink) {
      return logo;
    }

    return <div style={{ display: 'contents' }}>{logo}</div>;
  }
);

export default NavLogo;
